export default __webpack_public_path__ + "images/LY.67ff253.png";